// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__27KEO","col":"Table_col__2puC0","fulfillmentStatus":"Table_fulfillmentStatus__9YJFo","emailCol":"Table_emailCol__38Rnu"};